import React, { Component, Fragment } from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Alert } from 'antd'
import InfoText from '../../../../elements/InfoText'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'

const CheckboxTable = checkboxHOC(CustomTable)

class UploadCompareList extends Component {
  columns = [
    { Header: 'Name', accessor: 'name' },
    { Header: 'Desc', accessor: 'description' },
    { Header: 'Client Ref', accessor: 'materials.clientRef' },
    { Header: 'Material No', accessor: 'materials.no' },
    { Header: 'OEM', accessor: 'materials.oem.fn' },
    { Header: 'OEM No', accessor: 'materials.oem.no' },
    { Header: 'Qty', accessor: 'unit' },
    { Header: 'UOM', accessor: 'uom.code' },
    { Header: 'Country', accessor: 'materials.country' },
    { Header: 'Delivery', accessor: 'delivery.label' },
    { Header: 'Rep', accessor: 'rep.fn' },
    { Header: 'Email', accessor: 'rep.email.label' },
  ]

  render () {
    const { list, selectAll, selection, isSelected, toggleSelection, toggleAll } = this.props
    const checkboxProps = {
      selectType: 'checkbox',
      selectAll,
      isSelected,
      toggleSelection,
      toggleAll,
    }

    console.log({ list })
    return (
      <Fragment>
        <InfoText
          text={
            'This Table data is combined with the ones existed in the system to compare wither this data uploaded before.'
          }
        />
        <InfoText
          text={
            'You can differentiate between current transactions and to be uploaded ones by the Transaction ID and Green Badge in each row.'
          }
        />
        <InfoText text={'You can filter the table by clicking on the filter button.'}/>
        <br/>
        {selection.length > 0 && (
          <Alert message={`Records to be uploaded ${selection.length}`} type="info"/>
        )}
        <CheckboxTable
          columns={this.columns}
          data={list}
          hide={{ refresh: true }}
          indexKey={'_key'}
          isFilterable={true}
          defaultSorted={[
            {
              id: 'date',
              desc: false,
            },
            {
              id: 'amount',
              desc: false,
            },
          ]}
          {...checkboxProps}
        />
      </Fragment>
    )
  }
}

UploadCompareList.propTypes = {}
UploadCompareList.defaultProps = {}

export default UploadCompareList
